import type { APIResponse } from './base-fetch';
import { get } from './base-fetch';

export type DeploymentModel = APIResponse<'/api/v4/deployment-models'>[number];

export const fetchDeploymentModels = () =>
  get<DeploymentModel[]>('/v4/deployment-models');
